import { useEffect } from "react";
import { Link } from "react-router-dom";
import "./page.css";

function NotFound() {
  useEffect(() => {
    document.title = "Page not found · Mirrorkhan Tours";
  }, []);

  return (
    <section className="page section-block">
      <div className="container">
        <div className="row">
          <div className="col-lg-7">
            <p className="eyebrow">404</p>
            <h1 className="mb-3">This page is off the map.</h1>
            <p className="page-lead mb-4">
              The route you asked for is not one we publish.
            </p>
            <Link className="btn btn-mk-gold" to="/">
              Back home
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default NotFound;
